import generateFetchSimilarContentQueryParams from './fetchSimilarContentsHandler';
import { GQL_QUERIES } from '../../../utils/analytics/newrelic/ErrorTracker';
import {
  FETCH_SIMILAR_CONTENTS_QUERY,
  FETCH_SIMILAR_CONTENTS_QUERY_FOR_BOT_REQUEST
} from '../../GraphQL/Queries/SimilarContentQuery';
import { SimilarContent } from '../../GraphQL/Queries/types';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

export const fetchSimilarContents = async (
  contentId: string,
  country: string,
  languages = '',
  translation = 'en',
  isPersonalisedEnabled: boolean,
  isRequestedByBot?: boolean
): Promise<SimilarContent> => {
  try {
    const response: any = await graphQlRequest(
      isRequestedByBot
        ? FETCH_SIMILAR_CONTENTS_QUERY_FOR_BOT_REQUEST
        : FETCH_SIMILAR_CONTENTS_QUERY,
      generateFetchSimilarContentQueryParams(
        contentId,
        country,
        translation,
        languages,
        isPersonalisedEnabled
      ),
      GQL_QUERIES.FETCH_SIMILAR_CONTENTS_QUERY
    );
    return response.similarContent || {};
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};
